<template>
  <div class="OpenSsuBtn">
    <ShadowMask />
    <hot-spot @btnClick="hotSpotClick" />
    <btn-config
      :width="width"
      :height="height"
      has-bg-img
      :bg-start-color="bgStartColor"
      :bg-end-color="bgEndColor"
      :border-radius="borderRadius"
      :text="isOpen ? '收起' : '选规格'"
    />
  </div>
</template>
<script>
import HotSpot from '../newOperator/atoms/hotSpot'
import BtnConfig from '../newOperator/atoms/btnConfig'
import ShadowMask from '../newOperator/atoms/shadow'
export default {
  name: 'OpenSsuBtn',
  components: {
    HotSpot,
    BtnConfig,
    ShadowMask
  },
  props: {
    height: {
      type: [Number, String],
      default: 0.52 // 26px=>0.52rem
    },
    width: {
      type: [Number, String],
      default: 1.26
    },
    isOpen: {
      type: Boolean,
      default: false
    },
    borderRadius: {
      type: Number,
      default: 0.26 // 13px=>.26rem
    },
    bgStartColor: {
      type: String,
      default: '#FF8F48'
    },
    bgEndColor: {
      type: String,
      default: '#FF4C2D'
    }
  },
  data() {
    return {}
  },
  methods: {
    hotSpotClick() {
      this.$emit('update:on0penChange', !this.isOpen)
      this.$emit('openChange', !this.isOpen)
    }
  }
}
</script>
<style lang="scss" scoped>
.OpenSsuBtn {
  position: relative;
}
</style>
